import React from 'react';
import { Percent } from './icons';
import styles from './styles.module.css';
/**
 * Компонент DiscountPercentTag отображает процент скидки с соответствующей иконкой.
 *
 * @component
 * @example
 * <DiscountPercentTag percent={20} />
 *
 * @param {Object} props - Свойства компонента.
 * @param {number} props.percent - Значение процента скидки, c плавающей точкой, которое будет преобразовано
 * в процент для отображения в компоненте.
 *
 * @returns {React.Element} Отображает компонент скидки с иконкой.
 */
export const DiscountPercentTag = ({ percent, ...htmlProps }) => {
    const percentView = percent ? (percent * 100).toFixed() : '';
    return (React.createElement("div", { className: styles.container, ...htmlProps },
        React.createElement("span", null,
            "\u2212",
            percentView),
        React.createElement(Percent, null)));
};
//# sourceMappingURL=discount-percent-tag.js.map